module.exports = __webpack_public_path__ + "static/media/team3.09f47919.png";